import { useState, forwardRef, useEffect } from "react";
import {
  Button,
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
  IconButton,
  Grid,
  TextField,
  Paper,
} from "@mui/material";

import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import AgGridPaginatedTable from "../../components/AgGridPaginatedTable.jsx";

import { questionsTable } from "../../config/grid-column-defs.js";
import useSnackbar from "../../hooks/useSnackbar.js";
import { deleteQuestion, getCaseQuestions } from "../../api/caseQuestions.js";
import { DeleteForever } from "@mui/icons-material";

export default function Questions() {
  const { data: user } = useSelector((state) => state.user);

  const [loading, setLoading] = useState(true);

  const [deletingQuestionId, setDeletingQuestionId] = useState("");
  const [caseTypeFilter, setCaseTypeFilter] = useState("");

  const [questionsTableRefreshCount, setQuestionsTableRefreshCount] =
    useState(0);
  function refreshQuestionsTable() {
    setQuestionsTableRefreshCount((prev) => prev + 1);
  }

  useEffect(() => {
    if (questionsTable.some((m) => m.field === "action")) return;
    questionsTable.unshift({
      field: "action",
      headerName: "Action",
      maxWidth: 100,
      cellRenderer: () => (
        <IconButton size="small" variant="contained" color="error">
          <DeleteForever />
        </IconButton>
      ),
    });
  }, [questionsTable]);
  useEffect(() => {
    refreshQuestionsTable();
  }, [caseTypeFilter]);

  function onQuestionTableCellClicked({ colDef, data }) {
    if (colDef.field === "action") {
      setDeletingQuestionId(data.id);
    }
  }

  async function getQuestionTableData(limit, offset) {
    try {
      const { data } = await getCaseQuestions(user.token, {
        type: caseTypeFilter,
        limit,
        offset,
      });
      return { rows: data.data, total: data.total, error: false };
    } catch (error) {
      console.log(error);
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  const onDeleteComplete = () => {
    refreshQuestionsTable();
    setDeletingQuestionId("");
  };

  return (
    <>
      <Paper className="odr-card">
        <Box
          display="flex"
          justifyContent="space-between"
          className="odr-card-header"
        >
          <Grid
            container
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            rowSpacing={1}
          >
            <Grid item xs={12} sm={6} md={8} lg={8}>
              <Link to="new">
                <Button
                  variant="contained"
                  size="large"
                  color="primary"
                  className="blue-button"
                >
                  Create Question
                </Button>
              </Link>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                value={caseTypeFilter}
                label="Case Type"
                onChange={(e) => {
                  setCaseTypeFilter(e.target.value);
                }}
                size="small"
                fullWidth
                variant="outlined"
                // inputProps={{ style: { textTransform: "uppercase" } }}
              />
            </Grid>
          </Grid>
          {loading ? <CircularProgress /> : <></>}
        </Box>
        <div className="odr-main-table">
          <AgGridPaginatedTable
            getTableRows={getQuestionTableData}
            onCellClicked={onQuestionTableCellClicked}
            columns={questionsTable}
            perPage={10}
            refreshCounter={questionsTableRefreshCount}
          />
        </div>
        <DeleteMeetingDialog
          deletingQuestionId={deletingQuestionId}
          setOpen={setDeletingQuestionId}
          onDeleteComplete={onDeleteComplete}
          token={user.token}
        />
      </Paper>
    </>
  );
}

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function DeleteMeetingDialog({
  setOpen,
  deletingQuestionId,
  onDeleteComplete,
  token,
}) {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const handleClose = () => {
    setOpen("");
  };

  const handleDelete = async () => {
    try {
      await deleteQuestion(token, deletingQuestionId);
      snackbar.showSuccess("Question Deleted.");
      onDeleteComplete();
    } catch (error) {
      snackbar.showError();
      setOpen("");
    }
  };

  return (
    <Dialog
      open={Boolean(deletingQuestionId)}
      TransitionComponent={Transition}
      keepMounted
     // onClose={handleClose}
     onClose={() => {       
    }}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle className="heading-title">Delete Question</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          The question will be deleted forever.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          size="large"
          variant="outlined"
          className="black-border-button"
          onClick={handleClose}
        >
          Cancel
        </Button>

        <Button
          size="large"
          variant="text"
          color="error"
          onClick={handleDelete}
          className="red-boder-button"
          disabled={/^trial_user$/i.test(user.roles) ? true : false}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
